export const widgetName = 'chart';
export const widgetDisplayName = 'Chart';
export const widgetCategory = 'Reply.com';
export const widgetSelector = 'chart';
export const widgetEditorSelector = 'chart-editor';
export const widgetRuntimeSelector = 'chart-runtime';